let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8oY8A"), load("iB2zz"), load("c37CC")]).then(() => parcelRequire('cVptH'));